import * as Types from '../../gql.generated';

import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';
export type ReadUserQueryVariables = {
  id: Types.Scalars['String']
};


export type ReadUserQuery = (
  { __typename?: 'Query' }
  & { dbUser: Types.Maybe<(
    { __typename?: 'User' }
    & Pick<Types.User, '_id' | 'email' | 'department' | 'type' | 'upn' | 'firstName' | 'lastName' | 'name' | 'external' | 'companyName' | 'userType' | 'extension'>
  )> }
);

export type ReadWorkerQueryVariables = {
  id: Types.Scalars['String']
};


export type ReadWorkerQuery = (
  { __typename?: 'Query' }
  & { worker: Types.Maybe<(
    { __typename?: 'Worker' }
    & Pick<Types.Worker, '_id' | 'lastName' | 'firstName' | 'department' | 'inactive'>
  )> }
);

export const ReadUserDocument = gql`
    query ReadUser($id: String!) {
  dbUser(id: $id) {
    _id
    email
    department
    type
    upn
    firstName
    lastName
    name
    external
    companyName
    userType
    extension
  }
}
    `;

    export function useReadUserQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ReadUserQuery, ReadUserQueryVariables>) {
      return ApolloReactHooks.useQuery<ReadUserQuery, ReadUserQueryVariables>(ReadUserDocument, baseOptions);
    };
      export function useReadUserLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ReadUserQuery, ReadUserQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<ReadUserQuery, ReadUserQueryVariables>(ReadUserDocument, baseOptions);
      };
      
export type ReadUserQueryHookResult = ReturnType<typeof useReadUserQuery>;
export type ReadUserQueryResult = ApolloReactCommon.QueryResult<ReadUserQuery, ReadUserQueryVariables>;
export const ReadWorkerDocument = gql`
    query ReadWorker($id: String!) {
  worker(id: $id) {
    _id
    lastName
    firstName
    department
    inactive
  }
}
    `;

    export function useReadWorkerQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ReadWorkerQuery, ReadWorkerQueryVariables>) {
      return ApolloReactHooks.useQuery<ReadWorkerQuery, ReadWorkerQueryVariables>(ReadWorkerDocument, baseOptions);
    };
      export function useReadWorkerLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ReadWorkerQuery, ReadWorkerQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<ReadWorkerQuery, ReadWorkerQueryVariables>(ReadWorkerDocument, baseOptions);
      };
      
export type ReadWorkerQueryHookResult = ReturnType<typeof useReadWorkerQuery>;
export type ReadWorkerQueryResult = ApolloReactCommon.QueryResult<ReadWorkerQuery, ReadWorkerQueryVariables>;